import React from "react";
import BusinessInqueriesButton from "./BusinessInqueriesButton";
export default function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="heroTop">
        <div className="auto__container">
          <div className="hero__inner">
            <div className="hero__inner-content">
              <h1 id="hero-heading">
                Welcome to the Future of Hair Restoration, Welcome to{" "}
                <span>Proxium</span>.
              </h1>
              <p className="big">
                Where the forefront of technological innovation meets
                patient-centered care.
              </p>
              <BusinessInqueriesButton />
            </div>
            <div className="hero__inner-image">
              <img src="/images/gif.gif" alt="Proxium hair restoration technology animation" />
            </div>
            <a
              href="#about"
              className="hero__inner-arrow"
              aria-label="Scroll to About section"
              title="Go to About section"
            >
              <img src="/images/icons/arrow-down.svg" alt="" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
      <div className="heroFoot">
        <div className="auto__container">
          <div className="heroFoot__inner">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna.
            </p>
            <a
              href="#about"
              className="heroFoot__inner-arrow"
              aria-label="Scroll to About section"
              title="Go to About section"
            >
              <img src="/images/icons/arrow-down-gray.svg" alt="" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
